import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { ApiService } from '@root/app/services/api.service';
import { ApiResponse, Realtrip } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class RealtripService {
  private apiService = inject(ApiService);

  getRealtrip(id: number): Observable<ApiResponse<Realtrip>> {
    return this.apiService.get<Realtrip>('transportec_realtrips/' + id);
  }
}
